import { Field } from 'redux-form';

import AddressOnlyDisplay from 'common/components/address/AddressOnlyDisplay';
import { RadioButton } from 'common/components/forms';
import {
  convertShipCompliantTimeTOISODate,
  timeFormat
} from 'common/helpers/dateHelper';

const PickupLocation = (props) => {
  const { carrierPickupLocation, settings } = props;
  return (
    <div>
      <label
        className="c7-radio c7-checkout-pickup-locations"
        htmlFor={`radiocarrierPickupLocationId-${carrierPickupLocation.id}`}
      >
        <Field
          name="carrierPickupLocationId"
          component={RadioButton}
          label={carrierPickupLocation.id}
          type="radio"
          value={carrierPickupLocation.id}
          noLabel
        />
        <div className="c7-checkout-pickup-locations__address">
          <strong>{carrierPickupLocation.address.company}</strong>
          <br />
          <AddressOnlyDisplay address={carrierPickupLocation.address} />
          <br />
          Distance: {carrierPickupLocation.distance} mi
        </div>
        <div className="c7-checkout-pickup-locations__hours">
          {renderDay('Monday', carrierPickupLocation.hours.monday, settings)}
          {renderDay('Tuesday', carrierPickupLocation.hours.tuesday, settings)}
          {renderDay(
            'Wednesday',
            carrierPickupLocation.hours.wednesday,
            settings
          )}
          {renderDay(
            'Thursday',
            carrierPickupLocation.hours.thursday,
            settings
          )}
          {renderDay('Friday', carrierPickupLocation.hours.friday, settings)}
          {renderDay(
            'Saturday',
            carrierPickupLocation.hours.saturday,
            settings
          )}
          {renderDay('Sunday', carrierPickupLocation.hours.sunday, settings)}
        </div>
      </label>
    </div>
  );
};

const timeF = (time, settings) =>
  timeFormat(convertShipCompliantTimeTOISODate(time, settings), settings);

const renderDay = (dayAsString, day, settings) => {
  try {
    if (day.type === 'OPEN_ALL_DAY') {
      return (
        <>
          {dayAsString}: 24hrs
          <br />
        </>
      );
    }
    return (
      <>
        {dayAsString}: {timeF(day.openingTime, settings)} -{' '}
        {timeF(day.closingTime, settings)}
        <br />
      </>
    );
  } catch {
    return null;
  }
};

export default PickupLocation;
